const MenuIcon = () => {
  return (
    <div className="border-primary relative h-6 w-8 border-t-2 border-b-2">
      <div className="bg-primary absolute top-0 left-0 h-0.5 w-full"></div>
      <div className="bg-primary absolute top-2 left-0 h-1 w-3/4"></div>
      <div className="bg-primary absolute bottom-0 left-0 h-0.5 w-full"></div>
    </div>
  );
};

export default MenuIcon;
